import { render, staticRenderFns } from "./ListProfiles.vue?vue&type=template&id=10bc1433&scoped=true"
import script from "./ListProfiles.vue?vue&type=script&lang=js"
export * from "./ListProfiles.vue?vue&type=script&lang=js"
import style0 from "./ListProfiles.vue?vue&type=style&index=0&id=10bc1433&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bc1433",
  null
  
)

export default component.exports